import React from 'react';
import PropTypes from 'prop-types';
import { IconHeadlineTextCentered } from '../icon_headline_text_centered/icon_headline_text_centered';
import Translation from '../translation/translation';

export const Content = props => (
    <article className="friendbuy-light-box">
        <span
            className="friendbuy-light-box__close"
            onClick={props.onClose}
        />
        <header className="friendbuy-light-box__header">
            <Translation
                tagName="h1"
                className="friendbuy-light-box__headline"
                translationKey="friendbuy-lightbox-headline"
            />
            <div className="friendbuy-light-box__reductions_per_friends">
                <div className="friendbuy-light-box__reductions_per_friend">
                    <IconHeadlineTextCentered
                        iconPath="icons/man_style_one.svg"
                        headlineTag="h2"
                        headlineTranslationKey="friendbuy-lightbox-reduction-per-friend"
                        headlinePlaceholder={{ friends: 1, amount: '10%' }}
                        staticUrl={props.staticUrl}
                    />
                </div>
                <div className="friendbuy-light-box__reductions_per_friend">
                    <IconHeadlineTextCentered
                        iconPath="icons/two_people.svg?v=2"
                        headlineTag="h2"
                        headlineTranslationKey="friendbuy-lightbox-reduction-per-friends"
                        headlinePlaceholder={{ friends: 2, amount: '25%' }}
                        staticUrl={props.staticUrl}
                    />
                </div>
                <div className="friendbuy-light-box__reductions_per_friend">
                    <IconHeadlineTextCentered
                        iconPath="icons/three_people.svg"
                        headlineTag="h2"
                        headlineTranslationKey="friendbuy-lightbox-reduction-per-friends"
                        headlinePlaceholder={{ friends: 3, amount: '50%' }}
                        staticUrl={props.staticUrl}
                    />
                </div>
            </div>
        </header>
        <main className="friendbuy-light-box__content">
            <Translation
                tagName="h2"
                className="friendbuy-light-box__text-headline"
                translationKey="friendbuy-lightbox-how-it-works"
            />

            <ol>
                <Translation
                    tagName="li"
                    translationKey="friendbuy-lightbox-step-1"
                    className="friendbuy-light-box__matesrates-link"
                    placeholder={{
                        baseUrl: props.baseUrl,
                        storeUrl: props.storeUrl,
                    }}
                />

                <Translation
                    tagName="li"
                    translationKey="friendbuy-lightbox-step-2"
                />

                <Translation
                    tagName="li"
                    translationKey="friendbuy-lightbox-step-3"
                />
            </ol>

            <p className="friendbuy-light-box__tip">
                <Translation translationKey="friendbuy-lightbox-tip"/>
                {' '}
                <span className="friendbuy-light-box__tnc">
                    <Translation
                        translationKey="friendbuy-lightbox-tnc"
                        placeholder={{
                            baseUrl: props.baseUrl,
                        }}
                    />
                </span>
            </p>

            <Translation
                tagName="button"
                className="friendbuy-light-box__primary-cta"
                onClick={props.onClose}
                translationKey="friendbuy-lightbox-button"
            />
        </main>
    </article>
);

Content.propTypes = {
    staticUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    storeUrl: PropTypes.string.isRequired,
};
